import { SettingLandingBannersUsInformationContainer } from "..";

export const SettingLandingBannersUsMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingBannersUsInformationContainer />
    </div>
  );
};
